import { ChipiProvider } from './app-router/client/ChipiProvider';

export { ChipiProvider };
